import { render, staticRenderFns } from "./500.vue?vue&type=template&id=bbec6cf4&scoped=true&"
var script = {}
import style0 from "./500.vue?vue&type=style&index=0&id=bbec6cf4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbec6cf4",
  null
  
)

export default component.exports